import { useToast } from 'primevue/usetoast';

export interface DownloadReportToastComposable {
  showToast(): void;
}

export default function useDownloadReportToast(): DownloadReportToastComposable {
  const toast = useToast();

  function showToast(): void {
    toast.add({ severity: 'success', group: 'download-report', life: 5000 });
  }

  return {
    showToast,
  };
}
